import BackendAPI from '~/api/BackendClient/BackendAPI'
import { components } from '~/api/BackendClient/generated-schema'

export type CustomCultureStatusResponse =
  components['schemas']['CustomCultureStatusResponse']
export type CustomCultureStatusIcon = components['schemas']['CustomCultureStatusIcon']
export type CustomCultureStatusCategory = components['schemas']['CategoryChoices']

class CustomCultureStatusAPI extends BackendAPI {
  getAll = (): Promise<CustomCultureStatusResponse[]> => {
    return this.client.GET('/api/custom-culture-status/')
  }

  create = (body: {
    name: string
    icon: CustomCultureStatusIcon
    category: CustomCultureStatusCategory
  }): Promise<CustomCultureStatusResponse> => {
    return this.client.POST('/api/custom-culture-status/', {
      body,
    })
  }

  update = (
    id: string,
    body: {
      name: string | null
      icon: CustomCultureStatusIcon | null
      category: CustomCultureStatusCategory | null
      is_archived: boolean | null
    },
  ): Promise<CustomCultureStatusResponse> => {
    return this.client.PUT('/api/custom-culture-status/{id}', {
      params: {
        path: { id },
      },
      body,
    })
  }
}

export default CustomCultureStatusAPI
